import { render, staticRenderFns } from "./IncidencesCard.vue?vue&type=template&id=40fa13f6&"
import script from "./IncidencesCard.vue?vue&type=script&lang=js&"
export * from "./IncidencesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports